import type { TagJSONObject } from '@ikegps/core-api';
import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { T } from '../../i18n';
import type { MithrilVNode } from '../../mithril';
import { VerifyWorkbenchCtrl } from './verify.workbench.ctrl';

/**
 * Placeholder icon until the custom Verify SVG (UFO-148) is provided.
 * ImageButton accepts MaterialIcon | MithrilVNode, so swapping this for the SVG
 * vnode when it arrives is a one-line change.
 */
const VERIFY_ICON: MaterialIcon | MithrilVNode = MaterialIcon.OPEN_IN_NEW;

/** Button shown next to a job name (on hover) to open that whole job in Verify. */
function view(job: TagJSONObject): MithrilVNode | null {
	if (!VerifyWorkbenchCtrl.canOpenInVerify(job)) {
		return null;
	}

	return ImageButton.view(VERIFY_ICON, {
		title: T.OPEN_JOB_IN_VERIFY,
		testId: 'open-job-in-verify',
		onclick: (event) => {
			event.stopPropagation();
			VerifyWorkbenchCtrl.openJobInVerify(job);
		},
	});
}

export const JobVerifyButton = { view };
